module.exports = __webpack_public_path__ + "img/complete.9ef1d504.svg";